/**
 * Campañas de mail del comercio (`/activa/emails/campanas`): todas, las que están enviando arriba, cada una con cómo
 * le fue desde que salió. Los borradores aparecen sin números («Todavía no salió»).
 */

import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { emailsApi } from "../api";
import type { ListaCampanas } from "../types";
import { usePedido } from "../hooks/usePedido";
import { useEstadoEmails } from "../contexto";
import { Esqueleto, ErrorTarjeta } from "../../wa-oficial/components/estadisticas/comun";
import { useEsEquipoDeenex } from "../../campana-nueva/hooks/useEsEquipoDeenex";
import { num, plural } from "../../campana-nueva/utils/format";
import { TablaCampanas } from "../components/TablaCampanas";
import { ErrorRefresco } from "../components/ErrorRefresco";
import { R_EMAILS } from "../logic/emails";

export default function CampanasEmailsPage() {
  const { version } = useEstadoEmails();
  const equipo = useEsEquipoDeenex();
  const r = usePedido<ListaCampanas>(() => emailsApi.campanas(), "campanas", { refresco: version });
  const filas = r.dato?.filas || [];

  return (
    <div className="space-y-5">
      <header>
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight">Campañas de mail</h2>
        <p className="text-sm text-slate-500 mt-1">
          {r.dato ? `${num(filas.length)} ${plural(filas.length, "campaña", "campañas")} en Snov` : "Las campañas de Snov de este comercio"}
        </p>
        {r.dato && r.error && <ErrorRefresco error={r.error} onReintentar={r.recargar} />}
      </header>
      {!r.dato ? (
        r.error ? <ErrorTarjeta texto={`No pudimos traer las campañas. ${r.error}`} onReintentar={r.recargar} /> : <Esqueleto alto="h-48" etiqueta="Cargando campañas" />
      ) : !filas.length ? (
        <div className="rounded-2xl border-2 border-dashed border-slate-200 p-10 text-center">
          <Mail size={22} className="mx-auto text-slate-300" />
          <p className="mt-3 text-sm text-slate-600">Todavía no hay campañas de mail de este comercio.</p>
          {equipo && (
            <p className="mt-1 text-xs text-slate-500">
              Se asignan por la casilla que las manda, en <Link to={`${R_EMAILS}/conexion`} className="font-semibold text-violet-700 underline">Conexión</Link>.
            </p>
          )}
        </div>
      ) : (
        <TablaCampanas filas={filas} />
      )}
    </div>
  );
}
